import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class Pruning extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_vegetative_1.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Pruning
        </h2>
        <p>
        As your plants grow you’ll want to prune them with a good pair of <a target="_blank" href="https://www.amazon.com/gp/product/B01MU8CP1W/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01MU8CP1W&linkCode=as2&tag=blacksquare05-20&linkId=5df4a19c0e5207a6b1fb01d8db4c2059">Pruning Fiskars</a><img src="//ir-na.amazon-adsystem.com/e/ir?t=blacksquare05-20&l=am2&o=1&a=B01MU8CP1W" width="1" height="1" alt="" className="amazon__pixel" />. Remove any brown or damaged leaves as you find them. You may also want to chop off small branches. These won’t produce much bud anyway while sapping valuable energy from the plant. Removing these smaller branches will help focus all of the plant’s energy and growth into your main kolas where the majority of your bud will grow. These smaller branches also make excellent clones. 
        </p>
        <h3>
        Lollipopping
        </h3>
        <p>
        Another way to boost your plant growth is to remove any underbrush, a technique called lollipopping. This name comes from the fact that your plant will look like a lollipop if done properly. To lollipop remove all leaves and branches from the bottom third of your plant. These leaves won’t get much light anyway, and removing them can help with pest problems as bugs will have a harder time reaching the leaves and branches to nest in. 
        </p>
        <div className="guide__shopping-list">
          <h3>Shopping List</h3>

          <iframe className="amazon__iframe" marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=blacksquare05-20&marketplace=amazon&region=US&placement=B01MU8CP1W&asins=B01MU8CP1W&linkId=4745aa74bca724ba6245272d50eb6b9f&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>

        </div>
        <GuideButton slugTo="flowering-stage" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/two_pruning.js